import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {SubscriptionEvent } from "../models/SubscriptionEvent";
import {SubscriptionAccount } from "../models/SubscriptionAccount";
import {SubscriptionRequest } from "../models/SubscriptionRequest";
import { Observable, throwError } from 'rxjs';
 
import { retry, catchError } from 'rxjs/operators';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class IsoeventsubscriptionmangementserviceService {

  public apiUrl: string;
  public sourceId: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.baseUrl;
    this.sourceId = environment.sourceId;
   }

   httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  public async getEventDetails(): Promise<SubscriptionEvent[]>   {
    let result$:Observable<SubscriptionEvent[]> =  this.http
      .get<SubscriptionEvent[]>(this.apiUrl + '/GetSubscriptionEventsAsync/'+ this.sourceId)
      .pipe(retry(1), catchError(this.handleError));

      return result$.toPromise();  
  }

  
  getAllEventsDetails(): Observable<SubscriptionAccount[]>   {
    return this.http
      .get<SubscriptionAccount[]>(this.apiUrl + '/GetAllSubscriptionEventsAsync/')
      .pipe(retry(1), catchError(this.handleError));
  }

  getAllSubscriptionPerferencesAsync(email:string, uniqName:string): Observable<SubscriptionRequest>   {
    let content = {
      sourceId : this.sourceId,
      emailAddress:email,
      uniqueName:uniqName
    }; 

    return this.http
      .post<SubscriptionRequest>(this.apiUrl + '/getAllSubscriptionPerferencesAsync/',content)
      .pipe(retry(1), catchError(this.handleError));
  }
  

  getNoificationEventDetailsAsync(listid:string): Promise<SubscriptionEvent>   {
    let content = {
      sourceId : this.sourceId,
      listId:listid
    };

    console.log('getNoificationEventDetailsAsync');
    console.log(content);
 
    let eventDetails$:Observable<SubscriptionEvent> =   this.http
      .post<SubscriptionEvent>(this.apiUrl + '/getNoificationEventDetailsAsync/',content)
      .pipe(retry(1), catchError(this.handleError)); 

      return eventDetails$.toPromise(); 
  }


 sendUnsubscribeConfirmEmailAsync(email:string,listid:string): Promise<any>   {
    let content = {
      sourceId : this.sourceId,
      emailAddress:email,
      listId:listid
    };

    console.log('sendUnsubscribeConfirmEmailAsync');
    console.log(content);
 
    let subscriptionDetails$:Observable<any> =   this.http
      .post<any>(this.apiUrl + '/SendUnsubscriptionEmailAsync/',content)
      .pipe(retry(1), catchError(this.handleError)); 

      return subscriptionDetails$.toPromise(); 
  }



  unsubscribeNotificationEventAsync(email:string,listid:string,userId:string): Promise<string>   {
    let content = {
      sourceId : this.sourceId,
      emailAddress:email,
      unsubscribEventId:listid,
      uniqueName:userId
    };

    console.log('unsubscribeNotificationEventAsync');
    console.log(content);
 
    let subscriptionDetails$:Observable<string> =   this.http
      .post<string>(this.apiUrl + '/UnsubscribeFromEventAsync/',content)
      .pipe(retry(1), catchError(this.handleError)); 

      return subscriptionDetails$.toPromise(); 
  }


  getSubscriptionPerferencesByEmailAsync(email:string): Observable<SubscriptionRequest>   {
    let content = {
      sourceId : this.sourceId,
      emailAddress:email
    };

    console.log('getSubscriptionPerferencesByEmailAsync');
    console.log(content);
 
    return this.http
      .post<SubscriptionRequest>(this.apiUrl + '/getSubscriptionPerferencesByEmailAsync/',content)
      .pipe(retry(1), catchError(this.handleError));
  }
   
  getSubscriptionPerferences(email:string, uniqName:string): Observable<SubscriptionRequest>   {
    let content = {
      sourceId : this.sourceId,
      emailAddress:email,
      uniqueName:uniqName
    }; 

    return this.http
      .post<SubscriptionRequest>(this.apiUrl + '/GetSubscriptionPerferencesAsync/',content)
      .pipe(retry(1), catchError(this.handleError));
  }


  SubscribeToEvents(subscriptionReq:SubscriptionRequest): Observable<SubscriptionRequest>   {  
    subscriptionReq.sourceId = this.sourceId;
    console.log(this.apiUrl + '/SubscribeToEventsAsync/');
    console.log(subscriptionReq);
    return this.http
      .post<SubscriptionRequest>(this.apiUrl + '/SubscribeToEventsAsync/',subscriptionReq)
      .pipe(retry(1), catchError(this.handleError));
  }

  async UnsubscribeToEvents(subscriptionReq:SubscriptionRequest): Promise<SubscriptionRequest>   {
    subscriptionReq.sourceId = this.sourceId;  
    console.log(this.apiUrl + '/UnsubscribeToEventsAsync/');
    console.log(subscriptionReq);
    let subscriptionDetails$:Observable<SubscriptionRequest> =  this.http
      .post<SubscriptionRequest>(this.apiUrl + '/UnsubscribeToEventsAsync/',subscriptionReq)
      .pipe(retry(1), catchError(this.handleError));

      return subscriptionDetails$.toPromise(); 
  }

  UpdateAllSubscriptionPreferencesAsync(subscriptionReq:SubscriptionRequest): Observable<SubscriptionRequest>   { 
   var reqUrl =this.apiUrl + '/UpdateAllSubscriptionPreferencesAsync/';
   console.log(reqUrl);
    console.log(subscriptionReq);
    return this.http
      .post<SubscriptionRequest>(reqUrl,subscriptionReq)
      .pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
    console.error(error);
    return throwError(() => {
      return errorMessage;
    });
  }
}
